(function () {
  var DESKTOP_MIN = 990;
  var DESKTOP_PER_PAGE = 3;
  var MOBILE_PER_PAGE = 1;

  function visibleCount() {
    return window.innerWidth >= DESKTOP_MIN ? DESKTOP_PER_PAGE : MOBILE_PER_PAGE;
  }

  function init(root) {
    var viewport = root.querySelector('.moyshop-home-reviews__viewport');
    var track = root.querySelector('[data-mhr-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mhr-slide]'));
    var prev = root.querySelector('[data-mhr-prev]');
    var next = root.querySelector('[data-mhr-next]');
    var pager = root.querySelector('[data-mhr-pager]');
    if (!viewport || !track || slides.length === 0) return;

    var page = 0;
    var startX = 0;
    var dragging = false;
    var moved = false;

    function pageCount(vis) {
      return Math.ceil(slides.length / vis);
    }

    function maxPage(vis) {
      return Math.max(0, pageCount(vis) - 1);
    }

    function wrapPage(p, vis) {
      var max = maxPage(vis);
      if (max === 0) return 0;
      if (p < 0) return max;
      if (p > max) return 0;
      return p;
    }

    function updatePager(vis) {
      if (!pager) return;
      var needsPager = pageCount(vis) > 1;
      pager.hidden = !needsPager;
      if (prev) prev.disabled = !needsPager || page === 0;
      if (next) next.disabled = !needsPager || page >= maxPage(vis);
    }

    function getGap(vis) {
      return vis > 1 ? 16 : 0;
    }

    function pageOffset(page, vis, slideW, gap) {
      return page * vis * (slideW + gap);
    }

    function render() {
      var vis = visibleCount();
      page = wrapPage(page, vis);
      var gap = getGap(vis);
      var slideW = (viewport.clientWidth - gap * (vis - 1)) / vis;

      slides.forEach(function (slide, i) {
        slide.style.flex = '0 0 ' + slideW + 'px';
        slide.style.maxWidth = slideW + 'px';
        slide.style.width = slideW + 'px';
        slide.style.marginRight = i === slides.length - 1 ? '0px' : gap + 'px';
      });

      track.style.transform = 'translate3d(' + (-pageOffset(page, vis, slideW, gap)) + 'px,0,0)';
      updatePager(vis);
    }

    function step(dir) {
      page = wrapPage(page + dir, visibleCount());
      render();
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    viewport.addEventListener('pointerdown', function (e) {
      dragging = true;
      moved = false;
      startX = e.clientX;
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      if (Math.abs(e.clientX - startX) > 8) moved = true;
    });

    window.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
    });

    track.addEventListener('click', function (e) {
      if (!moved) return;
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }, true);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(render, 120);
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-mhr-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
